import { Navigate } from 'react-router-dom';
import { useCatalogEnabled } from '../../../util/useCatalogEnabled';
import { Catalog } from './Catalog';

/**
 * Route guard for /catalog: redirects to dashboard when the user does not have
 * Catalog enabled (neither via app instance set feature flag nor localStorage override).
 */
export const CatalogPage = () => {
  const catalogEnabled = useCatalogEnabled();

  if (!catalogEnabled) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Catalog />;
};
